import { useEffect, useState } from "react"
import SimpleBar from 'simplebar-react'

// material-ui
import { Drawer, Box, Toolbar } from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery';

// project import
import { useEventBusContext } from "services/provider/EventBusProvider"

export const EVENT_DARWER_FILTER_TOGGLE = 'DARWER_FILTER_TOGGLE'

export const FilterDrawer = ({ filter }) => {
    const [open, setOpen] = useState(false)
    const eventbus = useEventBusContext()
    const is_mobile = useMediaQuery('(max-width:767px)');
    const drawersx = { 
        zIndex: 1310, 
        '& .MuiPaper-root': { maxWidth: !is_mobile ? '370px' : '300px', width: '100%' }
    }

    useEffect(() => {
        return eventbus.on(EVENT_DARWER_FILTER_TOGGLE, () => {
            setOpen(!open)
        })
    }, [eventbus])

    return (<Drawer sx={drawersx} anchor="right" open={open} onClose={() => { setOpen(false); }}>
        <Toolbar sx={{ minHeight: '20px' }} />
        <Box>
            <SimpleBar
                sx={{
                    '& .simplebar-content': {
                        display: 'flex',
                        flexDirection: 'column'
                    }
                }}
            >
                {filter != null && filter()}
            </SimpleBar>
        </Box>

    </Drawer>)
}